import SocialConnectConnectorFacebook from './connector/facebook.mjs';
import SocialConnectConnectorGoogle from './connector/google.mjs';

window.socialConnectConnectorFacebook = new SocialConnectConnectorFacebook();
window.socialConnectConnectorGoogle = new SocialConnectConnectorGoogle();

export {
    SocialConnectConnectorFacebook,
    SocialConnectConnectorGoogle
};
